
import request from '@/utils/request';
import Vue from 'vue';
//获取大洲列表 
export function query(params) {
  return request({
    method: 'post',
    url: `${Vue.prototype.$conf.visaService}/visa/term/query`,
    data: params
  });
}
//创建大洲 
export function create(params) {
  return request({
    method: 'post',
    url: `${Vue.prototype.$conf.visaService}/visa/term/create`,
    data: params
  });
}
// 修改
export function update(params) {
  return request({
    method: 'post',
    url: `${Vue.prototype.$conf.visaService}/visa/term/update`,
    data: params
  });
}
// 删除 
export function deleteTerm(params) {
  return request({
    method: 'post',
    url: `${Vue.prototype.$conf.visaService}/visa/term/delete/${params}`
  });
}
//查询所有的大洲列表 
export function getAllTerms() {
  return request({
    method: 'get',
    url: `${Vue.prototype.$conf.visaService}/visa/term/getAll`
  });
}

export function getByBid(params) {
  return request({
    method: 'post',
    url: `${Vue.prototype.$conf.visaService}/visa/term/getByBid/${params}`
  });
}